import { ROUTE, axiosInstance } from './axiosInstance';

export const embeddedApps = {
  getToken: async (appId: string, { forceRefresh }: { forceRefresh?: boolean } = {}) => {
    const { data } = await axiosInstance.post<{ accessToken: string; expiresAt: number }>(ROUTE.EMBEDDED_APPS.TOKEN(appId), {
      forceRefresh,
    });
    return data;
  },
};
